import inView from 'in-view';

(function($) {
    // メニューの開閉処理を管理する関数
    function toggleMenu() {
        const $menu = $('.c-navbar-nav-footer');
        $menu.toggleClass('is_open');
    }

    // メニューを閉じる関数
    function closeMenu() {
        $('.c-navbar-nav-footer').removeClass('is_open');
    }

    // スクロール時にヘッダーの状態を更新する関数
    function updateHeaderOnScroll() {
        const heroElement = document.getElementById('hero');
        const headerWrapper = document.getElementById('header-wrapper');

        if (heroElement && headerWrapper) {
            const heroHeight = heroElement.offsetHeight;
            const isScrollPastHero = window.scrollY > heroHeight;

            headerWrapper.classList.toggle('active', isScrollPastHero);
        }
    }

    // カルーセルの設定を行う関数
    function setCarousel() {
        const $target = $('#carousel');
        const cardWidth = $('.c-carousel-card').outerWidth();

        $('#next').on('click', () => {
            $target.animate({
                scrollLeft: $target.scrollLeft() + cardWidth
            }, 500);
        });

        $('#prev').on('click', () => {
            $target.animate({
                scrollLeft: $target.scrollLeft() - cardWidth
            }, 500);
        });
    }

    // ページ読み込み完了時の処理
    function handleLoadComplete() {
        const loader = document.getElementById('loading');
        loader.classList.add('is_loaded');

        setTimeout(() => {
            loader.remove();
        }, 2000);
    }

    // InViewを利用して要素を監視する関数
    function setInViewWatch() {
        inView('.js-in-view').on('enter', (element) => {
            element.classList.add('active');
        });
    }

    function loadContentFromUrls(selector) {
        const elements = document.querySelectorAll(selector);

        // アンカーリンク判定をelements.forEachの前に移動
        const hasAnchor = window.location.hash !== ""; // アンカーリンクが存在するか判定

        elements.forEach((element) => {
            const url = element.getAttribute('data-url');

            fetch(url)
                .then(response => response.ok ? response.text() : Promise.reject('Network response was not ok'))
                .then(html => {
                    const container = document.createElement('div');
                    container.innerHTML = html;
                    element.parentNode.insertBefore(container, element.nextSibling);

                    setInViewWatch();

                    if(url.includes('news')) {
                        setCarousel();
                    }
                    if (url.includes('introduction')) {
                        showMoreContent();
                    }

                    if(url.includes('fieldnotes')) {
                        const filters = {
                            country: 'countryFilter',
                            author: 'authorFilter',
                            type: 'articleTypeFilter'
                        };
                        const postsSelector = '.c-fieldnotes';
                        const loadingSelector = 'loading-fieldnotes';
                        const noPostMessageElement = 'noPostsMessage';
                        new PostFilter(filters, postsSelector, loadingSelector, noPostMessageElement);
                    }
                })
                .catch(error => {
                    console.error('エラーが発生しました:', error);
                    const errorMessage = document.createElement('p');
                    errorMessage.textContent = 'コンテンツの読み込みに失敗しました。';
                    document.getElementById('content-container').appendChild(errorMessage);
                });
        }); // forEachの終わり

        // forEachの後、アンカーリンクが存在すればスクロールを実行
        if (hasAnchor) {
            setTimeout(() => {
                const anchor = document.getElementById(window.location.hash.substring(1));
                if (anchor) {
                    const headerHeight = document.querySelector('#header-wrapper').offsetHeight; // headerの高さを取得
                    const scrollTop = anchor.getBoundingClientRect().top + window.pageYOffset - headerHeight;

                    window.scrollTo({
                        top: scrollTop,
                        behavior: 'smooth'
                    });
                }
            }, 1000);
        }
    }
    class PostFilter {
        constructor(filters, posts, loadingElement, noPostsMessageElement) {
            this.filters = {
                country: document.getElementById(filters.country),
                author: document.getElementById(filters.author),
                type: document.getElementById(filters.type)
            };
            this.posts = document.querySelectorAll(posts);
            this.loadingElement = document.getElementById(loadingElement);
            this.noPostsMessageElement = document.getElementById(noPostsMessageElement);
            this.setupEventListeners();
        }

        setupEventListeners() {
            Object.values(this.filters).forEach(filter => filter.addEventListener('change', () => this.startFiltering()));
        }

        startFiltering() {
            this.showLoading();
            setTimeout(() => {
                this.filterPosts();
                this.hideLoading();
            }, 500);
        }

        showLoading() {
            this.posts.forEach(post => post.style.display = 'none');
            this.noPostsMessageElement.style.display = 'none';
            this.loadingElement.style.display = 'flex';
        }

        hideLoading() {
            this.loadingElement.style.display = 'none';
            if (!this.anyPostVisible()) {
                this.noPostsMessageElement.style.display = 'flex';
            } else {
                this.posts.forEach(post => {
                    if (post.style.display !== 'none') { // フィルタに合致して表示状態になっている記事のみ
                        post.style.opacity = 0;
                        post.style.display = '';
                        setTimeout(() => post.style.opacity = 1, 100); // わずかな遅延で透明度を1に変更してfadeIn効果を実現
                    }
                });
            }
        }

        anyPostVisible() {
            return Array.from(this.posts).some(post => post.style.display !== 'none');
        }

        filterPosts() {
            const selectedCountry = this.filters.country.value;
            const selectedAuthor = this.filters.author.value;
            const selectedType = this.filters.type.value;

            this.posts.forEach(post => {
                const matchesFilters = this.doesPostMatchFilters(post, selectedCountry, selectedAuthor, selectedType);
                post.style.display = matchesFilters ? '' : 'none';
            });
        }

        doesPostMatchFilters(post, country, author, type) {
            const postCountry = post.dataset.country ? post.dataset.country.split(', ') : null;
            const postAuthor = post.dataset.author ? post.dataset.author.split(', ') : null;
            const postType = post.dataset.type ? post.dataset.type.split(', ') : null;
            console.log(postType);

            const matchesCountry = !country || (postCountry && postCountry.includes(country));
            const matchesAuthor = !author || (postAuthor && postAuthor.includes(author));
            const matchesType = !type || (postType && postType.includes(type));

            return matchesCountry && matchesAuthor && matchesType;
        }
    }




    // 詳細を表示する関数
    function showMoreContent() {
        $('.js-view-more').on('click', () => {
            $('.js-hidden').removeClass('js-hidden');
            $('.js-hidden-after').hide();
            return false;
        });
    }

    // スムーススクロールを設定する関数
    function setSmoothScroll() {
        $('a[href*="#"]').on('click', function(event) {
            const targetId = this.href.split('#')[1];
            if (!targetId || window.location.pathname !== '/') return;

            event.preventDefault();
            const target = $(`#${targetId}`);
            const position = target.offset().top - $('#header-wrapper').height();

            $('html, body').animate({ scrollTop: position }, 500, 'swing');
        });
    }

    // クッキーを設定する関数
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = `; expires=${date.toUTCString()}`;
        document.cookie = `${name}=${value || ""}${expires}; path=/`;
    }

    // クッキーを取得する関数
    function getCookie(name) {
        const nameEQ = `${name}=`;
        const cookies = document.cookie.split(';');

        for (let c of cookies) {
            c = c.trim();
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
        }
        return null;
    }

    // 初回訪問時の処理
    function handleFirstVisit() {
        const visitedBefore = getCookie('visitedBefore');
        if (!visitedBefore) {
            const langSwitcher = document.querySelector('.js-lang-switcher');
            langSwitcher && langSwitcher.classList.remove('d-none');
            setCookie('visitedBefore', true, 365);
        }
    }

    // 初期化関数
    function init() {
        $('.js-menu-icon').on('click', toggleMenu);
        $('#main-menu a').on('click', closeMenu);

        if (document.body.classList.contains('home')) {
            window.addEventListener('load', updateHeaderOnScroll);
            window.addEventListener('scroll', updateHeaderOnScroll);
        }

        setSmoothScroll();
        handleLoadComplete();
        loadContentFromUrls('.js-load-content');
        handleFirstVisit();


        const currentUrl = window.location.pathname; // 現在のURLパスを取得

        // 条件分岐: URLが /event/ または /en/event/ の場合
        if (currentUrl === '/event/' || currentUrl === '/en/event/') {
            setInViewWatch();
        }
    }

    $(init);

})(jQuery);
